/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetAllApInvoiceTransactionGeneralInputs200 } from '../model/getAllApInvoiceTransactionGeneralInputs200';
import type { GetAllApInvoiceTransactionGeneralInputsParams } from '../model/getAllApInvoiceTransactionGeneralInputsParams';
import type { GetApInvoiceTransactionBasicItem200 } from '../model/getApInvoiceTransactionBasicItem200';
import type { GetApInvoiceTransactionGeneralInput200 } from '../model/getApInvoiceTransactionGeneralInput200';
import type { GetApInvoiceTransactionGeneralInputs200 } from '../model/getApInvoiceTransactionGeneralInputs200';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { PostApInvoiceTransactionGeneralInputs200 } from '../model/postApInvoiceTransactionGeneralInputs200';
import type { PostApInvoiceTransactionGeneralInputsBatchOptions200Item } from '../model/postApInvoiceTransactionGeneralInputsBatchOptions200Item';
import type { PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem } from '../model/postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem';
import type { PostApInvoiceTransactionGeneralInputsBody } from '../model/postApInvoiceTransactionGeneralInputsBody';
import type { PutApInvoiceTransactionGeneralInput200 } from '../model/putApInvoiceTransactionGeneralInput200';
import type { PutApInvoiceTransactionGeneralInputBody } from '../model/putApInvoiceTransactionGeneralInputBody';
import type { ReorderApInvoiceTransactionGeneralInputsBody } from '../model/reorderApInvoiceTransactionGeneralInputsBody';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateApInvoiceTransactionBasicItem200 } from '../model/updateApInvoiceTransactionBasicItem200';
import type { UpdateApInvoiceTransactionBasicItemBody } from '../model/updateApInvoiceTransactionBasicItemBody';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get a list of AP invoice transaction general inputs for a specific report type
 */
export const useGetApInvoiceTransactionGeneralInputsHook = () => {
  const getApInvoiceTransactionGeneralInputs =
    useCustomClient<GetApInvoiceTransactionGeneralInputs200>();

  return (
    reportTypeId: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApInvoiceTransactionGeneralInputs(
      {
        url: `/api/js/report_types/${reportTypeId}/ap_invoice_transaction_general_inputs`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApInvoiceTransactionGeneralInputsQueryKey = (
  reportTypeId: string
) => {
  return [
    `/api/js/report_types/${reportTypeId}/ap_invoice_transaction_general_inputs`,
  ] as const;
};

export const useGetApInvoiceTransactionGeneralInputsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  reportTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputsQueryKey(reportTypeId);

  const getApInvoiceTransactionGeneralInputs =
    useGetApInvoiceTransactionGeneralInputsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionGeneralInputs(reportTypeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportTypeId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
  >
>;
export type GetApInvoiceTransactionGeneralInputsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get a list of AP invoice transaction general inputs for a specific report type
 */
export const useGetApInvoiceTransactionGeneralInputs = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  reportTypeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApInvoiceTransactionGeneralInputsQueryOptions(
    reportTypeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  reportTypeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputsQueryKey(reportTypeId);

  const getApInvoiceTransactionGeneralInputs =
    useGetApInvoiceTransactionGeneralInputsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionGeneralInputs(reportTypeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!reportTypeId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
    >
  >;
export type GetApInvoiceTransactionGeneralInputsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get a list of AP invoice transaction general inputs for a specific report type
 */
export const useGetApInvoiceTransactionGeneralInputsSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  reportTypeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputsSuspenseQueryOptions(
      reportTypeId,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Create an AP invoice transaction general input for a specific report type
 */
export const usePostApInvoiceTransactionGeneralInputsHook = () => {
  const postApInvoiceTransactionGeneralInputs =
    useCustomClient<PostApInvoiceTransactionGeneralInputs200>();

  return (
    reportTypeId: string,
    postApInvoiceTransactionGeneralInputsBody: BodyType<PostApInvoiceTransactionGeneralInputsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postApInvoiceTransactionGeneralInputs(
      {
        url: `/api/js/report_types/${reportTypeId}/ap_invoice_transaction_general_inputs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postApInvoiceTransactionGeneralInputsBody,
      },
      options
    );
  };
};

export const usePostApInvoiceTransactionGeneralInputsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    {
      reportTypeId: string;
      data: BodyType<PostApInvoiceTransactionGeneralInputsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePostApInvoiceTransactionGeneralInputsHook>>
  >,
  TError,
  {
    reportTypeId: string;
    data: BodyType<PostApInvoiceTransactionGeneralInputsBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const postApInvoiceTransactionGeneralInputs =
    usePostApInvoiceTransactionGeneralInputsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApInvoiceTransactionGeneralInputsHook>
      >
    >,
    {
      reportTypeId: string;
      data: BodyType<PostApInvoiceTransactionGeneralInputsBody>;
    }
  > = (props) => {
    const { reportTypeId, data } = props ?? {};

    return postApInvoiceTransactionGeneralInputs(
      reportTypeId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApInvoiceTransactionGeneralInputsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePostApInvoiceTransactionGeneralInputsHook>>
  >
>;
export type PostApInvoiceTransactionGeneralInputsMutationBody =
  BodyType<PostApInvoiceTransactionGeneralInputsBody>;
export type PostApInvoiceTransactionGeneralInputsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Create an AP invoice transaction general input for a specific report type
 */
export const usePostApInvoiceTransactionGeneralInputs = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof usePostApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    {
      reportTypeId: string;
      data: BodyType<PostApInvoiceTransactionGeneralInputsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePostApInvoiceTransactionGeneralInputsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get an AP invoice transaction basic item
 */
export const useGetApInvoiceTransactionBasicItemHook = () => {
  const getApInvoiceTransactionBasicItem =
    useCustomClient<GetApInvoiceTransactionBasicItem200>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApInvoiceTransactionBasicItem(
      {
        url: `/api/js/ap_invoice_transaction_basic_items/${id}`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApInvoiceTransactionBasicItemQueryKey = (id: string) => {
  return [`/api/js/ap_invoice_transaction_basic_items/${id}`] as const;
};

export const useGetApInvoiceTransactionBasicItemQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApInvoiceTransactionBasicItemQueryKey(id);

  const getApInvoiceTransactionBasicItem =
    useGetApInvoiceTransactionBasicItemHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionBasicItem(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionBasicItemQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >
>;
export type GetApInvoiceTransactionBasicItemQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get an AP invoice transaction basic item
 */
export const useGetApInvoiceTransactionBasicItem = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApInvoiceTransactionBasicItemQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionBasicItemSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApInvoiceTransactionBasicItemQueryKey(id);

  const getApInvoiceTransactionBasicItem =
    useGetApInvoiceTransactionBasicItemHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionBasicItem(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionBasicItemSuspenseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >
>;
export type GetApInvoiceTransactionBasicItemSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get an AP invoice transaction basic item
 */
export const useGetApInvoiceTransactionBasicItemSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetApInvoiceTransactionBasicItemHook>>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApInvoiceTransactionBasicItemSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update AP invoice transaction basic item
 */
export const useUpdateApInvoiceTransactionBasicItemHook = () => {
  const updateApInvoiceTransactionBasicItem =
    useCustomClient<UpdateApInvoiceTransactionBasicItem200>();

  return (
    id: string,
    updateApInvoiceTransactionBasicItemBody: BodyType<UpdateApInvoiceTransactionBasicItemBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateApInvoiceTransactionBasicItem(
      {
        url: `/api/js/ap_invoice_transaction_basic_items/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateApInvoiceTransactionBasicItemBody,
      },
      options
    );
  };
};

export const useUpdateApInvoiceTransactionBasicItemMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateApInvoiceTransactionBasicItemHook>>
    >,
    TError,
    { id: string; data: BodyType<UpdateApInvoiceTransactionBasicItemBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useUpdateApInvoiceTransactionBasicItemHook>>
  >,
  TError,
  { id: string; data: BodyType<UpdateApInvoiceTransactionBasicItemBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateApInvoiceTransactionBasicItem =
    useUpdateApInvoiceTransactionBasicItemHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateApInvoiceTransactionBasicItemHook>>
    >,
    { id: string; data: BodyType<UpdateApInvoiceTransactionBasicItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateApInvoiceTransactionBasicItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateApInvoiceTransactionBasicItemMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useUpdateApInvoiceTransactionBasicItemHook>>
  >
>;
export type UpdateApInvoiceTransactionBasicItemMutationBody =
  BodyType<UpdateApInvoiceTransactionBasicItemBody>;
export type UpdateApInvoiceTransactionBasicItemMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update AP invoice transaction basic item
 */
export const useUpdateApInvoiceTransactionBasicItem = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateApInvoiceTransactionBasicItemHook>>
    >,
    TError,
    { id: string; data: BodyType<UpdateApInvoiceTransactionBasicItemBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpdateApInvoiceTransactionBasicItemMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get a list of available AP invoice transaction general inputs
 */
export const useGetAllApInvoiceTransactionGeneralInputsHook = () => {
  const getAllApInvoiceTransactionGeneralInputs =
    useCustomClient<GetAllApInvoiceTransactionGeneralInputs200>();

  return (
    params: GetAllApInvoiceTransactionGeneralInputsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getAllApInvoiceTransactionGeneralInputs(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs`,
        method: 'GET',
        params,
        signal,
      },
      options
    );
  };
};

export const getGetAllApInvoiceTransactionGeneralInputsQueryKey = (
  params: GetAllApInvoiceTransactionGeneralInputsParams
) => {
  return [
    `/api/js/ap_invoice_transaction_general_inputs`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetAllApInvoiceTransactionGeneralInputsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetAllApInvoiceTransactionGeneralInputsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllApInvoiceTransactionGeneralInputsQueryKey(params);

  const getAllApInvoiceTransactionGeneralInputs =
    useGetAllApInvoiceTransactionGeneralInputsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
      >
    >
  > = ({ signal }) =>
    getAllApInvoiceTransactionGeneralInputs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllApInvoiceTransactionGeneralInputsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
    >
  >
>;
export type GetAllApInvoiceTransactionGeneralInputsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get a list of available AP invoice transaction general inputs
 */
export const useGetAllApInvoiceTransactionGeneralInputs = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetAllApInvoiceTransactionGeneralInputsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetAllApInvoiceTransactionGeneralInputsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetAllApInvoiceTransactionGeneralInputsSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetAllApInvoiceTransactionGeneralInputsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllApInvoiceTransactionGeneralInputsQueryKey(params);

  const getAllApInvoiceTransactionGeneralInputs =
    useGetAllApInvoiceTransactionGeneralInputsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
      >
    >
  > = ({ signal }) =>
    getAllApInvoiceTransactionGeneralInputs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAllApInvoiceTransactionGeneralInputsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
      >
    >
  >;
export type GetAllApInvoiceTransactionGeneralInputsSuspenseQueryError =
  ErrorType<UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>;

/**
 * @summary Get a list of available AP invoice transaction general inputs
 */
export const useGetAllApInvoiceTransactionGeneralInputsSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
    >
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(
  params: GetAllApInvoiceTransactionGeneralInputsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetAllApInvoiceTransactionGeneralInputsHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetAllApInvoiceTransactionGeneralInputsSuspenseQueryOptions(
      params,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get an AP invoice transaction general input
 */
export const useGetApInvoiceTransactionGeneralInputHook = () => {
  const getApInvoiceTransactionGeneralInput =
    useCustomClient<GetApInvoiceTransactionGeneralInput200>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getApInvoiceTransactionGeneralInput(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${id}`,
        method: 'GET',
        signal,
      },
      options
    );
  };
};

export const getGetApInvoiceTransactionGeneralInputQueryKey = (id: string) => {
  return [`/api/js/ap_invoice_transaction_general_inputs/${id}`] as const;
};

export const useGetApInvoiceTransactionGeneralInputQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputQueryKey(id);

  const getApInvoiceTransactionGeneralInput =
    useGetApInvoiceTransactionGeneralInputHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionGeneralInput(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
  >
>;
export type GetApInvoiceTransactionGeneralInputQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get an AP invoice transaction general input
 */
export const useGetApInvoiceTransactionGeneralInput = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetApInvoiceTransactionGeneralInputQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetApInvoiceTransactionGeneralInputSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApInvoiceTransactionGeneralInputQueryKey(id);

  const getApInvoiceTransactionGeneralInput =
    useGetApInvoiceTransactionGeneralInputHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
    >
  > = ({ signal }) =>
    getApInvoiceTransactionGeneralInput(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApInvoiceTransactionGeneralInputSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
    >
  >;
export type GetApInvoiceTransactionGeneralInputSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Get an AP invoice transaction general input
 */
export const useGetApInvoiceTransactionGeneralInputSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>>
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<typeof useGetApInvoiceTransactionGeneralInputHook>
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetApInvoiceTransactionGeneralInputSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update an AP invoice transaction general input
 */
export const usePutApInvoiceTransactionGeneralInputHook = () => {
  const putApInvoiceTransactionGeneralInput =
    useCustomClient<PutApInvoiceTransactionGeneralInput200>();

  return (
    id: string,
    putApInvoiceTransactionGeneralInputBody: BodyType<PutApInvoiceTransactionGeneralInputBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return putApInvoiceTransactionGeneralInput(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putApInvoiceTransactionGeneralInputBody,
      },
      options
    );
  };
};

export const usePutApInvoiceTransactionGeneralInputMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePutApInvoiceTransactionGeneralInputHook>>
    >,
    TError,
    { id: string; data: BodyType<PutApInvoiceTransactionGeneralInputBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof usePutApInvoiceTransactionGeneralInputHook>>
  >,
  TError,
  { id: string; data: BodyType<PutApInvoiceTransactionGeneralInputBody> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const putApInvoiceTransactionGeneralInput =
    usePutApInvoiceTransactionGeneralInputHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof usePutApInvoiceTransactionGeneralInputHook>>
    >,
    { id: string; data: BodyType<PutApInvoiceTransactionGeneralInputBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApInvoiceTransactionGeneralInput(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApInvoiceTransactionGeneralInputMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof usePutApInvoiceTransactionGeneralInputHook>>
  >
>;
export type PutApInvoiceTransactionGeneralInputMutationBody =
  BodyType<PutApInvoiceTransactionGeneralInputBody>;
export type PutApInvoiceTransactionGeneralInputMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update an AP invoice transaction general input
 */
export const usePutApInvoiceTransactionGeneralInput = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof usePutApInvoiceTransactionGeneralInputHook>>
    >,
    TError,
    { id: string; data: BodyType<PutApInvoiceTransactionGeneralInputBody> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    usePutApInvoiceTransactionGeneralInputMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Delete an AP invoice transaction general input
 */
export const useDeleteApInvoiceTransactionGeneralInputHook = () => {
  const deleteApInvoiceTransactionGeneralInput = useCustomClient<void>();

  return (
    id: string,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return deleteApInvoiceTransactionGeneralInput(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/${id}`,
        method: 'DELETE',
      },
      options
    );
  };
};

export const useDeleteApInvoiceTransactionGeneralInputMutationOptions = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useDeleteApInvoiceTransactionGeneralInputHook>
      >
    >,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useDeleteApInvoiceTransactionGeneralInputHook>>
  >,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const deleteApInvoiceTransactionGeneralInput =
    useDeleteApInvoiceTransactionGeneralInputHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useDeleteApInvoiceTransactionGeneralInputHook>
      >
    >,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApInvoiceTransactionGeneralInput(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApInvoiceTransactionGeneralInputMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useDeleteApInvoiceTransactionGeneralInputHook>>
  >
>;

export type DeleteApInvoiceTransactionGeneralInputMutationError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Delete an AP invoice transaction general input
 */
export const useDeleteApInvoiceTransactionGeneralInput = <
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useDeleteApInvoiceTransactionGeneralInputHook>
      >
    >,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useDeleteApInvoiceTransactionGeneralInputMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Get a batch of AP invoice transaction general input options
 */
export const usePostApInvoiceTransactionGeneralInputsBatchOptionsHook = () => {
  const postApInvoiceTransactionGeneralInputsBatchOptions =
    useCustomClient<
      PostApInvoiceTransactionGeneralInputsBatchOptions200Item[]
    >();

  return (
    postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: BodyType<
      PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[]
    >,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return postApInvoiceTransactionGeneralInputsBatchOptions(
      {
        url: `/api/js/ap_invoice_transaction_general_inputs/batch_options`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
      },
      options
    );
  };
};

export const getPostApInvoiceTransactionGeneralInputsBatchOptionsQueryKey = (
  postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[]
) => {
  return [
    `/api/js/ap_invoice_transaction_general_inputs/batch_options`,
    postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
  ] as const;
};

export const usePostApInvoiceTransactionGeneralInputsBatchOptionsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
        >
      >
    >,
    TError = ErrorType<
      BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
    >
  >(
    postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[],
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPostApInvoiceTransactionGeneralInputsBatchOptionsQueryKey(
        postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem
      );

    const postApInvoiceTransactionGeneralInputsBatchOptions =
      usePostApInvoiceTransactionGeneralInputsBatchOptionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
          >
        >
      >
    > = () =>
      postApInvoiceTransactionGeneralInputsBatchOptions(
        postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
        requestOptions
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type PostApInvoiceTransactionGeneralInputsBatchOptionsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
        >
      >
    >
  >;
export type PostApInvoiceTransactionGeneralInputsBatchOptionsQueryError =
  ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>;

/**
 * @summary Get a batch of AP invoice transaction general input options
 */
export const usePostApInvoiceTransactionGeneralInputsBatchOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
      >
    >
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >
>(
  postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[],
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
            >
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePostApInvoiceTransactionGeneralInputsBatchOptionsQueryOptions(
      postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const usePostApInvoiceTransactionGeneralInputsBatchOptionsSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
        >
      >
    >,
    TError = ErrorType<
      BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
    >
  >(
    postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[],
    options?: {
      query?: Partial<
        UseSuspenseQueryOptions<
          Awaited<
            ReturnType<
              ReturnType<
                typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
              >
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<ReturnType<typeof useCustomClient>>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPostApInvoiceTransactionGeneralInputsBatchOptionsQueryKey(
        postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem
      );

    const postApInvoiceTransactionGeneralInputsBatchOptions =
      usePostApInvoiceTransactionGeneralInputsBatchOptionsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
          >
        >
      >
    > = () =>
      postApInvoiceTransactionGeneralInputsBatchOptions(
        postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
        requestOptions
      );

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type PostApInvoiceTransactionGeneralInputsBatchOptionsSuspenseQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
        >
      >
    >
  >;
export type PostApInvoiceTransactionGeneralInputsBatchOptionsSuspenseQueryError =
  ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>;

/**
 * @summary Get a batch of AP invoice transaction general input options
 */
export const usePostApInvoiceTransactionGeneralInputsBatchOptionsSuspense = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
      >
    >
  >,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >
>(
  postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem: PostApInvoiceTransactionGeneralInputsBatchOptionsBodyItem[],
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof usePostApInvoiceTransactionGeneralInputsBatchOptionsHook
            >
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    usePostApInvoiceTransactionGeneralInputsBatchOptionsSuspenseQueryOptions(
      postApInvoiceTransactionGeneralInputsBatchOptionsBodyItem,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Reorder the AP invoice transaction general inputs
 */
export const useReorderApInvoiceTransactionGeneralInputsHook = () => {
  const reorderApInvoiceTransactionGeneralInputs = useCustomClient<void>();

  return (
    apReportTypeId: string,
    reorderApInvoiceTransactionGeneralInputsBody: BodyType<ReorderApInvoiceTransactionGeneralInputsBody>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return reorderApInvoiceTransactionGeneralInputs(
      {
        url: `/api/js/report_types/${apReportTypeId}/ap_invoice_transaction_general_inputs/order`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: reorderApInvoiceTransactionGeneralInputsBody,
      },
      options
    );
  };
};

export const useReorderApInvoiceTransactionGeneralInputsMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReorderApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    {
      apReportTypeId: string;
      data: BodyType<ReorderApInvoiceTransactionGeneralInputsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useReorderApInvoiceTransactionGeneralInputsHook>
    >
  >,
  TError,
  {
    apReportTypeId: string;
    data: BodyType<ReorderApInvoiceTransactionGeneralInputsBody>;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const reorderApInvoiceTransactionGeneralInputs =
    useReorderApInvoiceTransactionGeneralInputsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReorderApInvoiceTransactionGeneralInputsHook>
      >
    >,
    {
      apReportTypeId: string;
      data: BodyType<ReorderApInvoiceTransactionGeneralInputsBody>;
    }
  > = (props) => {
    const { apReportTypeId, data } = props ?? {};

    return reorderApInvoiceTransactionGeneralInputs(
      apReportTypeId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderApInvoiceTransactionGeneralInputsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useReorderApInvoiceTransactionGeneralInputsHook>
      >
    >
  >;
export type ReorderApInvoiceTransactionGeneralInputsMutationBody =
  BodyType<ReorderApInvoiceTransactionGeneralInputsBody>;
export type ReorderApInvoiceTransactionGeneralInputsMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Reorder the AP invoice transaction general inputs
 */
export const useReorderApInvoiceTransactionGeneralInputs = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReorderApInvoiceTransactionGeneralInputsHook>
      >
    >,
    TError,
    {
      apReportTypeId: string;
      data: BodyType<ReorderApInvoiceTransactionGeneralInputsBody>;
    },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useReorderApInvoiceTransactionGeneralInputsMutationOptions(options);

  return useMutation(mutationOptions);
};
